export const teamRoles = {
	EDITOR: "editor",
	PROOFER: "proofer",
	MANAGER: "manager",
	READER: "reader",
	RECORDER: "recorder",
	SUBCONTRACTOR: "subcontractor",
	PUBLISHER_MANAGER: "publisher_manager",
};
